import { useState } from 'react';
import { P2GImage } from '@parcel2go/core-ui';
import { useServiceLogo } from '~/hooks/use-service-logo';

export interface QuoteCardProps {
  courierId?: string;
  courierName?: string;
  width?: number;
  wrapper: (children: React.ReactNode) => React.ReactNode;
}

export function CourierLogo({ width, courierId, courierName, wrapper }: QuoteCardProps) {
  const { getCourierSrc } = useServiceLogo();
  const [failed, setFailed] = useState(false);

  if (failed || !courierId || !courierName) {
    return null;
  }

  return wrapper(
    <P2GImage
      style={{ width: width }}
      onError={() => setFailed(true)}
      src={getCourierSrc(courierId)}
      alt={courierName}
    />
  );
}
